// src/utils/formatDate.js

function convertToTimezone(dateString) {
  if (!dateString) return null;

  const tz = localStorage.getItem("timezone") || "UTC";
  const timeFormat = localStorage.getItem("timeFormat") || "24";

  try {
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: timeFormat === "12",
    });

    const parts = formatter.formatToParts(new Date(dateString));
    const get = (type) => parts.find((p) => p.type === type)?.value;

    return {
      day: get("day"),
      month: get("month"),
      year: get("year"),
      hour: get("hour"),
      minute: get("minute"),
      second: get("second"),
      period: get("dayPeriod") || "",
    };
  } catch {
    return null;
  }
}

// WITH TIME
export function formatCreatedAt(dateString) {
  const d = convertToTimezone(dateString);
  if (!d) return "";

  if (localStorage.getItem("timeFormat") === "12") {
    return `${d.day}-${d.month}-${d.year} ${d.hour}:${d.minute}:${d.second} ${d.period}`;
  }

  return `${d.day}-${d.month}-${d.year} ${d.hour}:${d.minute}:${d.second}`;
}

// DATE ONLY
export function formatDateOnly(dateString) {
  const d = convertToTimezone(dateString);
  if (!d) return "";

  return `${d.day}-${d.month}-${d.year}`;
}
